<template>
	<v-container class="justify-center">
	
		<v-row  justify ="center">
			<v-col cols="12">
				<v-card class="mx-auto elevation-0" max-width="600">  <!-- 374 -->
					<v-img :src="bussiness.photo_url" v-if="bussiness.homeimageheader"/>
					<v-card-text>
						<OverDueBilling v-if="isOverdueBilling" />
						
						<div v-else>

							<CollectionNotFound v-if="!collectionFound"/>

							 <Featured v-if="collectionFound  && bussiness.active "/> 
							<SimpleHome v-if="collectionFound  && !bussiness.template && bussiness.active "/> 
							<ToolBarHome v-if="collectionFound && bussiness.template && bussiness.active "/> 	
							<Categories v-if="collectionFound && bussiness.template && bussiness.active"/> 

						</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import moment from 'moment';
	import { mapState, mapActions } from "vuex";
	import {db} from '@/main';
	export default {
		 name: 'Home',
		components: {
			
			ToolBarHome: () => import('@/components/ToolBarHomeComponent'),
			SimpleHome: () => import('@/components/SimpleHomeComponent'),
			Featured: () => import('@/components/FeaturedComponent'),
			Categories: () => import('@/components/CategoriesComponent'),
			CollectionNotFound: () => import('@/components/ColectionNotFoundComponent'),
			OverDueBilling: () => import('@/components/OverdueBilling'),
		},
		mounted(){
			//Si id viene vacio 404
			if (!this.$route.params.id) {
				this.$store.dispatch('toggleCollectionFound', false, { root: true })
			} else {

				// Buscar si ID de negocio existe
				if (this.bussiness !== ''){
					const refBiss = db.collection('bussiness').doc(this.$route.params.id)
					refBiss.get()
						.then( (snap) => {
							if (snap.exists) {
								this.$store.dispatch('toggleCollectionFound', true, { root: true })
								refBiss.onSnapshot((doc) => {
									this.$store.dispatch('setBussinessId', this.$route.params.id, { root: true })
									this.$store.dispatch('setBussiness', doc.data(), { root: true })
									//console.log(doc.data())
								});
								this.$store.dispatch('setLoaded', true, { root: true })

							} else {
								this.$store.dispatch('toggleCollectionFound', false, { root: true })
								this.$store.dispatch('setLoaded', true, { root: true })
							}
						})
				}
			
			} //.else
			
		},
		methods: {
			...mapActions(['toggleCollectionFound','setBussiness','setBussinessId', 'setLoaded']),
			
			
		},			
		computed: {
			...mapState(['collectionFound','bussiness', 'bussinessId','loaded']),
			isOverdueBilling(){
				return this.bussiness.expiration_date  < moment(Date.now()).unix() 
			}
		},
	}
</script>

<style scoped>

</style>